import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import queryString from 'query-string';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import ConfirmConfiguration from '../containers/Dashboard/Modals/ConfirmConfiguration';

import { isEmpty, isEqual } from 'lodash';

import { headerContent } from '../localization/en-us/headerContent';

import SearchInput from '../containers/Global/SearchInput';
import BobConfirmButton from './BobConfirmButton';

import * as configurationActions from '../actions/configurationActions';
import * as DashboardActions from '../actions/dashboardActions';

import classes from './BobContextMenu.module.css';

const BobConfiguration = ({
    activeConfiguration,
    configurations,
    currentUser,
    emails,
    formulaGridColumns,
    healthscoreRawData,
    history,
    setActiveConfiguration,
    setShowSaveConfigurationModal,
    setShowSaveAsConfigurationModal,
    showSaveConfigurationModal,
    showSaveAsConfigurationModal,
    selectedRule,
    selectedRuleSensors,
    selectedSensors,
    selectedWeatherSensors,
    setIsClearAppliedConfiguration,
    setSelectedRule,
    setSelectedRuleSensors,
    setSelectedSensors,
    setSensorConfiguration,
    setUpdateConfigurationData,
    setSelectedWeatherSensors,
    ...props
}) => {
    const [configurationList, setConfigurationList] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const queryValues = queryString.parse(history.location.search);
    const [enableSaveConfiguration, setEnableSaveConfiguration] = useState(false);

    useEffect(() => {
        setConfigurationList(configurations);
    },[configurations]);

    useEffect(() => {
        if (queryValues.type && (queryValues.type === 'optimization' || queryValues.type === 'inspection')) {
            setEnableSaveConfiguration(true);
        } else {
            if (isEmpty(selectedSensors) && isEmpty(selectedRuleSensors) && isEmpty(healthscoreRawData)) {
                setEnableSaveConfiguration(false);
            } else {
                setEnableSaveConfiguration(true);
            }
        }
    }, [selectedSensors, selectedRuleSensors, queryValues]);

    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const toggleSaveConfigurationModal = () => {
        setMenuOpen(false);
        setShowSaveConfigurationModal(!showSaveConfigurationModal);
    };

    const handleSearch = searchFilter => {
        setSearchValue(searchFilter);
        const filteredconfigurations = configurations.filter(view => view.name.toLowerCase().includes(searchFilter.toLowerCase()));

        setConfigurationList(filteredconfigurations);
    };

    const handleOpen = () => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        const queryValuesString = queryString.stringify(queryValues);

        history.push({
            pathname: `/v2/dashboard/configuration`,
            search:   queryValuesString,
            state:    { 'returnUrl': `${pathname}` }
        });

        setMenuOpen(false);
    };
    
    const clearActiveConfiguration = () => {
        setSelectedRule([]);
        setSelectedRuleSensors([]);
        setSelectedSensors([]);
        setActiveConfiguration({});
        setIsClearAppliedConfiguration(true);
        setSelectedWeatherSensors([]);

        if (queryValues.viewChildId && 
            (queryValues.viewChildId === '4b25aeb8-02d4-4522-9f77-870ab40abb07' || queryValues.viewChildId === '4b25aeb8-02d4-4522-9f77-870ab40abb74')) {
            setSensorConfiguration({});
        }
        setMenuOpen(false);
    };

    const handleChangetabView = viewType => {
        const queryValues = queryString.parse(history.location.search);
        const { pathname } = history.location;

        if (viewType === 'Equipment - Configuration') {
            queryValues.viewChildId = '4b25aeb8-02d4-4522-9f77-870ab40abb07'; 
            queryValues.childId = '4b25aeb8-75d4-4522-9f77-870ab40abb07';
        } else if (viewType === 'System - Configuration') {
            queryValues.viewChildId = '4b25aeb8-02d4-4522-9f77-870ab40abb74'; 
            queryValues.childId = '383849dd-bd20-4ee2-a0e5-1b192ddc4f81';
        }
        
        const queryValueString = queryString.stringify(queryValues);
                
        history.push(`${pathname}?${queryValueString}`);
    };

    const updateActiveConfiguration = () => {
        if (!isEmpty(activeConfiguration)) {
            if (queryValues.type && (queryValues.type === 'optimization' || queryValues.type === 'inspection')) {
                setUpdateConfigurationData(true);
            } else if (!isEmpty(selectedSensors)) {
                const { viewData } = activeConfiguration;

                if (queryValues.viewChildId && 
                (queryValues.viewChildId === '4b25aeb8-77d4-4522-9f77-870ab40abb07' || 
                queryValues.viewChildId === '4b25aeb8-79d4-4522-9f77-870ab40abb07' || 
                queryValues.viewChildId === '4b25aeb8-77d4-4522-9f77-870ab40abb02' || 
                queryValues.viewChildId === '4b25aeb8-79d4-4522-9f77-870ab40abb03')) {
                    if (viewData.viewType === 'Equipment - Configuration') {
                        handleChangetabView(viewData.viewType);
                    } else if (viewData.viewType === 'System - Configuration') {
                        handleChangetabView(viewData.viewType);
                    } else {
                        setUpdateConfigurationData(true);
                    }
                } else {
                    setUpdateConfigurationData(true);
                }
            }
        }
        setMenuOpen(false);
    };

    const toggleSaveAsConfigurationModal = () => {
        setShowSaveAsConfigurationModal(!showSaveAsConfigurationModal);
    };

    let isViewOwner = false; 
    if ( !isEmpty(activeConfiguration) && !isEmpty(currentUser) && activeConfiguration.viewData.ownerId === currentUser.id) {
        isViewOwner = true;
    }
    
    let notChanged = false;
    if (!isEmpty(activeConfiguration)) {
        const { viewKey, viewData } = activeConfiguration;

        if (viewKey === 'BOB|Report|OptimizationReport' || viewKey === 'BOB|Report|InspectionReport') {
            notChanged = true;
        } else if (!isEmpty(selectedSensors)) {
            if (!isEmpty(viewData.selectedSensors)) {
                if (isEqual(viewData.selectedSensors, selectedSensors) &&
                isEqual(viewData.selectedWeatherSensors === undefined ? [] : viewData.selectedWeatherSensors, selectedWeatherSensors) &&
                isEqual(viewData.selectedFormulaColumns === undefined ? [] : viewData.selectedFormulaColumns, formulaGridColumns)) {
                    notChanged = true;
                }
            }
        }
    }

    let showSavedViewList = false;

    // Equipment Dashboard
    if ( queryValues.childId === '4b25aeb8-75d4-4522-9f77-870ab40abb07' ) {
        if (queryValues.viewChildId && queryValues.viewChildId !== '4b25aeb8-61d4-4522-9f77-870ab40abb07') {
            showSavedViewList = true;
        }
    }

    // System Dashboard
    if ( queryValues.childId === '383849dd-bd20-4ee2-a0e5-1b192ddc4f81' ) {
        if (queryValues.viewChildId && queryValues.viewChildId !== '4b25aeb8-61d4-4522-9f77-870ab40abb05') {
            showSavedViewList = true;
        }
    }

    // Reporting Page
    if (queryValues.type === 'optimization' || queryValues.type === 'inspection') {
        showSavedViewList = true;
    }
    
    return (
        <React.Fragment>
            <ClickAwayListener
                onClickAway={() => setMenuOpen(false)}
            >   
                { 
                    showSavedViewList ?
                        <div className={`${classes.BobContextMenu} ${classes.BobConfiguration}`}>
                            <Button
                                onClick={handleToggle}
                            >
                                <span className="material-icons-outlined">
                                    visibility
                                </span>
                                <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                            </Button>
                            { 
                                menuOpen ?
                                    <Paper className={classes.BobConfigurationContainer}>
                                        <div className={classes.SaveViewButtonContainer}>
                                            <BobConfirmButton
                                                className={classes.ConfigurationButton}
                                                //disabled={isEmpty(selectedSensors) && isEmpty(selectedRuleSensors)}
                                                disabled={!enableSaveConfiguration}
                                                onClick={toggleSaveConfigurationModal}
                                            >
                                                <span className={`material-icons-outlined ${classes.ConfigurationIconSpace}`}>
                                                    add
                                                </span>
                                                {'Save View & configuration'}
                                            </BobConfirmButton>
                                        </div>
                                        <div className={classes.ListContainer}>
                                            <small>Saved Views on this Page</small>
                                            <div className={classes.List}>
                                                <SearchInput
                                                    className={classes.SearchInput}
                                                    placeholder={`${headerContent.search}`}
                                                    search={handleSearch}
                                                    value={searchValue}
                                                    noRadius
                                                />
                                                {
                                                    isEmpty(configurationList) ?
                                                        <p className={classes.NoConfiguration}>No Configurations Found</p> : 
                                                        <List className={classes.BobConfigurationList}>
                                                            {configurationList.map((item, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    onClick={() => { 
                                                                        setActiveConfiguration(item);
                                                                        setMenuOpen(false);
                                                                    }}
                                                                    classes={{
                                                                        root: classes.ListItem
                                                                    }}
                                                                >
                                                                    {item.name}
                                                                    {
                                                                        activeConfiguration.name === item.name && notChanged ?
                                                                            <i className={`fa fa-check ${classes.CheckIcon}`} /> : null
                                                                    }
                                                                    {
                                                                        activeConfiguration.name === item.name && !notChanged ?
                                                                            <span className={`material-icons-outlined ${classes.EditNoteIcon}`}>
                                                                                edit_note
                                                                            </span>: null
                                                                    }
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                }
                                            </div>
                                        </div>
                                        {
                                            !isEmpty(activeConfiguration) ?
                                                <div className={classes.ConfigurationButtonContainer}>
                                                    <BobConfirmButton
                                                        disabled={queryValues.type && (queryValues.type === 'optimization' || queryValues.type === 'inspection') ? false : isEmpty(selectedSensors)}
                                                        onClick={toggleSaveAsConfigurationModal}
                                                    >
                                                        Save As
                                                    </BobConfirmButton>
                                                    {
                                                        isViewOwner ?
                                                            <BobConfirmButton
                                                                disabled={queryValues.type && (queryValues.type === 'optimization' || queryValues.type === 'inspection') ? false : isEmpty(selectedSensors)}
                                                                onClick={updateActiveConfiguration}
                                                            >
                                                                Update
                                                            </BobConfirmButton>
                                                            : null
                                                    }
                                                    <BobConfirmButton
                                                        onClick={clearActiveConfiguration}
                                                    >
                                                        Clear
                                                    </BobConfirmButton>
                                                </div>
                                                : null
                                        }
                                        <div className={classes.MyViewButtonContainer}>
                                            <BobConfirmButton
                                                onClick={handleOpen}
                                                className={classes.ConfigurationButton}
                                            >
                                                <span className={`material-icons-outlined ${classes.ConfigurationIconSpace}`}>
                                                    visibility
                                                </span>
                                                {'My Views & Configurations'}
                                            </BobConfirmButton>
                                        </div>
                                    </Paper> :
                                    null
                            }
                        </div>
                        :
                        <div className={`${classes.BobContextMenu} ${classes.BobConfiguration}`}>
                            <Button
                                onClick={handleToggle}
                            >
                                <span className="material-icons-outlined">
                                    visibility
                                </span>
                                <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                            </Button>
                            {
                                menuOpen ?
                                    <Paper className={classes.BobConfigurationContainer}>
                                        <div className={classes.MyViewButtonContainer}>
                                            <BobConfirmButton
                                                onClick={handleOpen}
                                                className={classes.ConfigurationButton}
                                            >
                                                <span className={`material-icons-outlined ${classes.ConfigurationIconSpace}`}>
                                                    visibility
                                                </span>
                                                {'My Views & Configurations'}
                                            </BobConfirmButton>
                                        </div>
                                    </Paper> :
                                    null
                            }
                        </div>
                }
            </ClickAwayListener>
            <React.Fragment>
                {
                    showSaveConfigurationModal ?
                        <ConfirmConfiguration
                            action={'save'}
                            toggleSaveConfigurationModal={toggleSaveConfigurationModal}
                            setMenuOpen={() => setMenuOpen(false)}
                            hideIsDefault={queryValues.type && (queryValues.type === 'optimization' || queryValues.type === 'inspection')}
                        />
                        :
                        null
                }
                { showSaveAsConfigurationModal ?
                    <ConfirmConfiguration
                        action={'saveAs'}
                        selectedConfiguration={activeConfiguration}
                        toggleSaveConfigurationModal={toggleSaveAsConfigurationModal}
                        setMenuOpen={() => setMenuOpen(false)}
                        hideIsDefault={queryValues.type && (queryValues.type === 'optimization' || queryValues.type === 'inspection')}
                    />
                    :
                    null
                }
            </React.Fragment>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        activeConfiguration:          state.configurationData.activeConfiguration,
        configurations:               state.configurationData.configurations,
        currentUser:                  state.currentUser,
        emails:                       state.dashboard.emails,
        formulaGridColumns:           state.dashboard.formulaGridColumns,
        healthscoreRawData:           state.dashboard.healthscoreRawData,
        selectedRule:                 state.dashboard.selectedRule,
        selectedRuleSensors:          state.dashboard.selectedRuleSensors,
        selectedSensors:              state.dashboard.selectedSensors,
        selectedWeatherSensors:       state.dashboard.selectedWeatherSensors,
        showSaveConfigurationModal:   state.configurationData.showSaveConfigurationModal,
        showSaveAsConfigurationModal: state.configurationData.showSaveAsConfigurationModal
    };
};

const mapDispatchToProps = {
    ...configurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BobConfiguration));
